import React from 'react';
import { ArrowLeft, ShoppingBag } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/shop.css';

const ShopPage = () => {
  return (
    <div className="shop-page">
      {/* Hero Section */}
      <section className="shop-hero">
        <div className="shop-hero-content">
          <div className="shop-badge">
            <ShoppingBag size={16} />
            Merch
          </div>
          <h1 className="shop-hero-title">Cal Fit Apparel</h1>
          <p className="shop-hero-subtitle">
            Wear the movement. Rep the mission.
          </p>
        </div>
        
        {/* Merch Preview Gallery */}
        <div className="merch-preview-gallery">
          <div className="merch-preview-item">
            <img 
              src="https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/le0dd900_Cal_hoodieWoods.JPG"
              alt="GoCalFit GoBungeeFit Hoodie"
              className="merch-image"
            />
          </div>
          <div className="merch-preview-item">
            <img 
              src="https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/1sl3wz7q_Back_hoodie.JPG"
              alt="Take a Load Off and Get High Hoodie Back"
              className="merch-image"
            />
          </div>
          <div className="merch-preview-item">
            <img 
              src="https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/bxdi9xsm_Cal_Tank.JPG"
              alt="GoCalFit GoBungeeFit Tank Top"
              className="merch-image"
            />
          </div>
        </div>
      </section>

      {/* Shop Form Section */}
      <section className="shop-form-section">
        <div className="shop-form-intro">
          <h2>Browse & Order</h2>
          <p>Select your gear below. All orders ship or are available for studio pickup.</p>
        </div>
        
        <div className="shop-embed-container" data-testid="shop-embed-container">
          <iframe
            id="JotFormIFrame-261185227087056"
            title="CAL FIT Apparel"
            allowtransparency="true"
            allow="geolocation; microphone; camera; fullscreen; payment"
            src="https://pci.jotform.com/form/261185227087056"
            frameBorder="0"
            className="shop-iframe"
            data-testid="shop-iframe"
          />
        </div>
      </section>
    </div>
  );
};

export default ShopPage;
